import React, { useContext } from 'react';
import { Fragment } from 'react';
import ReactPlayer from 'react-player';
import { HelpCenterContext } from './Context/HelpCenterContext';

export const VideoArticleDetail = () => {
    const { state, dispatch } = useContext(HelpCenterContext)
    const dataItem = state.selectedVideoArticle
    return (
        <div className="me-2">
            {state.showDetailComponent &&
                <Fragment>
                    <div className='mb-3'>
                        <strong className="font-size-1">{dataItem.text}</strong>
                    </div>
                    {dataItem.videoUrl &&
                        <div className="videoPlayer border my-4">
                            <ReactPlayer
                                controls={true}
                                playing={false}
                                width="100%"
                                fullscreen={true}
                                height="210px"
                                url={dataItem.videoUrl}
                            />
                        </div>
                    }
                    <p className="article-description">{dataItem.description}</p>
                    {dataItem.image && <img className='d-block m-auto hc-img' src={dataItem.image} alt={dataItem.text} />}
                    {dataItem.learnMoreUrl && <a href={dataItem.learnMoreUrl} target="_blank" rel="noreferrer" className="text-primary font-size-0">Click here to learn more <i className="fa-solid fa-arrow-up-right-from-square ms-2"></i></a>}
                    <div className="mt-4">
                        <div className='mb-3'>
                            <strong>Relevent Topic: {dataItem.keyword}</strong>
                        </div>
                        {
                            state.searchKeyword === "" ?
                                state.dataItem.Article
                                    .filter(item => (item.text !== dataItem.text))
                                    .slice(0, 2)
                                    .map(item => (
                                        <div className="mb-3" onClick={() => dispatch({ type: "TOGGLE_DETAIL_COMPONENT", payload: item })}>
                                            <h6 className="topic-links">{item.text}</h6>
                                            <small className="card-text text-muted d-block">{item.keyword} - <span>{item.tag}</span></small>
                                        </div>
                                    ))
                                :
                                state.searchResult
                                    .filter(item => item.text !== dataItem.text)
                                    .slice(0, 2)
                                    .map(item => (
                                        <div className="mb-3" onClick={() => dispatch({ type: "TOGGLE_DETAIL_COMPONENT", payload: item })}>
                                            <strong className="topic-links">{item.text}</strong>
                                            <small className="card-text text-muted d-block">{item.keyword} - <span>{item.tag}</span></small>
                                        </div>
                                    ))
                        }
                    </div>
                </Fragment>
            }
        </div>

    )
}